import { render, staticRenderFns } from "./TheLayoutDrawer.vue?vue&type=template&id=6fd45de1&"
import script from "./TheLayoutDrawer.vue?vue&type=script&lang=js&"
export * from "./TheLayoutDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd45de1')) {
      api.createRecord('6fd45de1', component.options)
    } else {
      api.reload('6fd45de1', component.options)
    }
    module.hot.accept("./TheLayoutDrawer.vue?vue&type=template&id=6fd45de1&", function () {
      api.rerender('6fd45de1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/TheLayoutDrawer.vue"
export default component.exports